export default function FieldError({ error }) {
  const msg = String(error || '').trim()
  if (!msg) return null
  return (
    <div style={{ color: '#a40000', fontSize: 12, marginTop: 2 }}>{msg}</div>
  )
}

